/*
  The search result as a card a slot can hold. `owned` and `sbcStorage` are
  all the search says about where a card sits, so the chip reads Club, SBC
  Storage or Market; the finer corners of the club are the solver's to know.
*/
export const toStreamlineOption = (player) => ({
    player,
    position: player.preferredPosition,
    price: player.priceInfo?.displayPrice ?? 0,
    source: player.sbcStorage ? "SBC-STORAGE" : player.owned ? "CLUB" : "MARKET",
    untradeable: player.owned && player.untradeable,
    eaPlayerId: player.owned && player.eaPlayerId ? player.eaPlayerId : undefined,
});
/** What a card is worth to the set; a card without a score ranks last. */
const itemScore = (player) => player.itemScore ?? 0;
const price = (player) => player.priceInfo?.displayPrice ?? 0;
/**
 * The club, worth-the-most-points first — and within one points value the
 * dearest card first, since spending a card the market prices highly is what
 * the club is for. Does not mutate the input.
 */
export const rankClubCards = (players) => [...players].sort((a, b) => itemScore(b) - itemScore(a) || price(b) - price(a));
/**
 * The market, worth-the-most-points first — and within one points value the
 * cheapest, which is the card to actually buy. Does not mutate the input.
 */
export const rankMarketCards = (players) => [...players].sort((a, b) => itemScore(b) - itemScore(a) || price(a) - price(b));
//# sourceMappingURL=search.js.map